// Utilidad para parsear 'YYYY-MM-DD' como UTC y evitar desfase de día
export const parseDateUTC = (day: string) => {
  const [year, month, date] = day.split('-').map(Number);
  return new Date(year, month - 1, date);
};

export const parseTime = (time: string | undefined) => {
  if (!time) {
    return new Date(0, 0, 0, 0, 0);
  }
  const [hours, minutes] = time.split(':');
  return new Date(0, 0, 0, parseInt(hours), parseInt(minutes));
};
